module.exports = __webpack_public_path__ + "cd3c5b6cd234fc54a568eb93f899eb04.svg";